import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

interface ChartHintProps {
    hintKey: string;
    fallbackHint: string;
}

/**
 * A hint icon component that displays chart explanations in a tooltip.
 * Used to provide context about what each chart shows and how to read it.
 */
const ChartHint = ({ hintKey, fallbackHint }: ChartHintProps) => {
    const { t } = useTranslation();

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 8,
                paddingTop: 8,
                borderTop: '1px dashed #f0f0f0',
            }}
        >
            <Tooltip
                title={
                    <Typography.Text style={{ color: '#fff', fontSize: '12px' }}>
                        {t(hintKey, fallbackHint)}
                    </Typography.Text>
                }
                placement="bottom"
                styles={{ root: { maxWidth: 350 } }}
            >
                <QuestionCircleOutlined
                    style={{
                        color: '#8c8c8c',
                        fontSize: '16px',
                        cursor: 'help',
                    }}
                />
            </Tooltip>
        </div>
    );
};

export default ChartHint;
